export default class EditReflectionCtrl {
  constructor ($scope, $mdDialog, PortfolioSrv, PortfolioModalSrv, GlobalConfig, FileUploader, SERVICE_URL_CONSTANT) {
  // constants
    const regexp = {
      image : /^(jpg|png|jpeg|bmp|gif)$/,
      audio : /^(mp3|mpeg-4|wma)$/,
      video : /^(mp4|mkv|avi|wmv)$/,
      document : /^(doc|docx|xls|xlsx|pdf)$/
    }
    var editReflectionVm       = this
    const shared         = PortfolioModalSrv.getVariable()
    const stylesClass    = ['', 'azul text-blanco']
    editReflectionVm.reflection = shared.reflection
    editReflectionVm.userId     = shared.userId
    editReflectionVm.startDate  = shared.startDate
    editReflectionVm.endDate    = shared.endDate
    
  // variables
    editReflectionVm.itemConfig          = GlobalConfig.itemListConfig
    editReflectionVm.globalFileTypes     = GlobalConfig.portfolioConfig.fileTypes
    editReflectionVm.comment             = ''
    editReflectionVm.fileName            = ''
    editReflectionVm.attachFile          = ''  
    editReflectionVm.classTitle          = 'col-md-3'
    editReflectionVm.loading             = false
    editReflectionVm.errorMsg            = false 
    editReflectionVm.errorMsgFileType    = ''
    editReflectionVm.disableButtonUpload = true
    editReflectionVm.showUploader        = false
    editReflectionVm.acceptFileType      = ''
    editReflectionVm.evidencesLinks      = []
    editReflectionVm.fileTypes           = []
    editReflectionVm.evidencesTypes      = []                          
    editReflectionVm.isRegistry          = true
    editReflectionVm.isLinking           = false
    editReflectionVm.isAddingEvidence    = false
    editReflectionVm.disableButtonAdd    = false
    

  // methods declaration
    editReflectionVm.close                 = close
    editReflectionVm.editReflection        = editReflection
    editReflectionVm.setClassTitle         = setClassTitle
    editReflectionVm.showErrorMessages     = showErrorMessages
    editReflectionVm.hasError              = hasError
    editReflectionVm.validateForm          = validateForm    
    editReflectionVm.remove                = remove
    editReflectionVm.cancel                = cancel
    editReflectionVm.linkEvidence          = linkEvidence
    editReflectionVm.showEvidencesToLink   = showEvidencesToLink
    editReflectionVm.setEvidence           = setEvidence
    editReflectionVm.removeLink            = removeLink
    editReflectionVm.showAddEvidenceToLink = showAddEvidenceToLink
    editReflectionVm.addLinkToReflection   = addLinkToReflection
    editReflectionVm.setFilterUploader     = setFilterUploader

    activate()
    
  // initial functions
    function activate(){
      setValues()
      PortfolioSrv.getBasicsRegistry.get().$promise.then((dataReturn) => {
        if (dataReturn.status) {
           editReflectionVm.fileTypes      = dataReturn.fileTypes
           editReflectionVm.evidencesTypes = dataReturn.evidencesTypes
        }
      })
      getEvidences()
    }

    function getEvidences(){
      let header = {
        userId    : editReflectionVm.userId,
        startDate : editReflectionVm.startDate,
        endDate   : editReflectionVm.endDate
      }
      PortfolioSrv.getEvidences.get(header).$promise.then(function (dataReturn) {
        if (dataReturn.status) {          
          editReflectionVm.evidences = dataReturn.data
        }
      }, function (data) {
          console.log(data)
      })
    }

    function setValues(){
      editReflectionVm.blogId           = editReflectionVm.reflection.blogId
      editReflectionVm.description      = editReflectionVm.reflection.blogDescription
      editReflectionVm.title            = editReflectionVm.reflection.blogTitle
      editReflectionVm.blogIsEnlighted  = editReflectionVm.reflection.blogIsEnlighted  
      editReflectionVm.evidencesLinks   = editReflectionVm.reflection.evidences    
    }

    function close () {
      PortfolioModalSrv.setVariable({status : false})
      return $mdDialog.hide()
    }  

  // methos for add elements
    function editReflection() {
      editReflectionVm.disableButtonAdd = true
      let header = {
        blogId         : editReflectionVm.blogId,
        description    : editReflectionVm.description,
        title          : editReflectionVm.title,
        isEnlighted    : (editReflectionVm.blogIsEnlighted ? 1 : 0),
        evidencesLinks : editReflectionVm.evidencesLinks
      }
      PortfolioSrv.updateReflection.update(header).$promise.then((dataReturn) => {
        if (dataReturn.status) {
          PortfolioModalSrv.setVariable({status : dataReturn.status})
          return $mdDialog.hide()
        }else{
          editReflectionVm.disableButtonAdd = false
        }
      })
      
    }

    function showEvidencesToLink(){
      editReflectionVm.errorMsgLinkEvidence = false
      editReflectionVm.isAddingEvidence     = false
      editReflectionVm.isLinking            = true
      editReflectionVm.isRegistry           = false      
    }

    function showAddEvidenceToLink(){
      editReflectionVm.errorMsgLinkEvidence = false
      editReflectionVm.isAddingEvidence     = true
      editReflectionVm.isLinking            = false
      editReflectionVm.isRegistry           = false   

      editReflectionVm.showUploader            = false
      editReflectionVm.descriptionLinkEvidence = null
      editReflectionVm.titleLinkEvidence       = null
      editReflectionVm.evidenceType            = null
      editReflectionVm.fileTypeId              = null
      editReflectionVm.fileName                = null
      remove()

    }

  // methods for link evidence to a new reflection
    function linkEvidence(){
      if(editReflectionVm.selectedEvidence){
        let header = {
          evidenceId        : editReflectionVm.selectedEvidence.evidence.blogId,
          evidenceFileName  : editReflectionVm.selectedEvidence.evidence.blogTitle,
          filetype          : editReflectionVm.selectedEvidence.evidence.blogFileType
        }
        editReflectionVm.evidencesLinks.push(header)
        cancel()
      } else {
        editReflectionVm.errorMsgLinkEvidence = true
      }
    }    

    function setEvidence(evidence, index){
      if (editReflectionVm.selectedEvidence){
        editReflectionVm.evidences[editReflectionVm.selectedEvidence.pos].isSelected = stylesClass[0]
        editReflectionVm.selectedEvidence = {
          evidence  : evidence,
          pos       : index
        }
        evidence.isSelected = stylesClass[1]
      } else {
        editReflectionVm.selectedEvidence = {
          evidence  : evidence,
          pos       : index
        }
        evidence.isSelected = stylesClass[1]
      }
      editReflectionVm.errorMsgLinkEvidence = false
    }  

    function removeLink(index){
      editReflectionVm.evidencesLinks.splice(index,1) 
    }

    function cancel () {
      editReflectionVm.isAddingEvidence = false
      editReflectionVm.isLinking        = false
      editReflectionVm.isRegistry       = true
      editReflectionVm.evidences[editReflectionVm.selectedEvidence.pos].isSelected = stylesClass[0]
      editReflectionVm.selectedEvidence = null

      editReflectionVm.descriptionLinkEvidence = null
      editReflectionVm.titleLinkEvidence       = null
      editReflectionVm.evidenceType            = null
      editReflectionVm.fileTypeId              = null
      editReflectionVm.fileName                = null
      remove()


    }

  // methods to add new evidence, and link to reflection
    function addLinkToReflection(){
      editReflectionVm.disableButtonAdd = true
      let header = {
        userId      : editReflectionVm.userId,
        description : editReflectionVm.descriptionLinkEvidence,
        title       : editReflectionVm.titleLinkEvidence,
        idSubitem   : editReflectionVm.evidenceType,
        fileType    : editReflectionVm.fileTypeId,
        fileName    : editReflectionVm.fileName //este valor debe obtener cuando el archivo sea adjuntado
      }
      PortfolioSrv.addEvidence.add(header).$promise.then((dataReturn) => {
        if (dataReturn.status) {
          let addedEvidence = {
            blogId       : dataReturn.reflectionId,
            blogTitle    : header.title,
            blogFileType : header.fileType
          }          
          editReflectionVm.selectedEvidence = {
                                          evidence  : addedEvidence,
                                          pos       : 0
                                        } 
          linkEvidence()
          editReflectionVm.disableButtonAdd = false
        }
      })

      
    }

  //upload methods
    function setFilterUploader(){
      let name = ''
      let extensions = '' 
      let pattern 
      if(isImageType(editReflectionVm.fileTypeId)){
        name       = 'imageFilter'
        extensions = '|jpg|png|jpeg|bmp|gif|'
        editReflectionVm.acceptFileType = 'image/*'
        pattern = regexp.image
      }
      if(isAudioType(editReflectionVm.fileTypeId)){
        name       = 'audioFilter'
        extensions = '|mp3|mpeg-4|wma|'
        editReflectionVm.acceptFileType = 'audio/*'
        pattern = regexp.audio
      }
      if(isVideoType(editReflectionVm.fileTypeId)){
        name       = 'videoFilter'
        extensions =  '|mp4|mkv|avi|wmv|'
        editReflectionVm.acceptFileType = 'video/*'
        pattern = regexp.video
      }
      if(isDocumentType(editReflectionVm.fileTypeId)){
        name       = 'documentFilter'
        extensions =  '|doc|docx|xls|xlsx|pdf|'
        editReflectionVm.acceptFileType = 'application/pdf,application/vnd.ms-excel,application/msword'
        pattern = regexp.document
      }

      uploader.filters.pop()
      uploader.filters.push({
          name: name,
          fn: function(item, options) {
                var type = '|' + item.type.slice(item.type.lastIndexOf('/') + 1) + '|'
                return extensions.indexOf(type) !== -1
              }
      })    
      editReflectionVm.showUploader = true
      $('#inputFileUpload').val(null)
      $('#inputFileUpload2').val(null)
      editReflectionVm.disableButtonUpload = true

      if (editReflectionVm.attachFile != ''){
        checkExtensionFile(editReflectionVm.fileTypeId,editReflectionVm.attachFile, pattern)
      }

    }

    function checkExtensionFile(fileType, filename, pattern){
      let ext = filename.substring(filename.lastIndexOf(".") + 1)
      if(pattern.test(ext)){
        editReflectionVm.errorMsgFileType = ''
      } else {
        editReflectionVm.errorMsgFileType = 'El archivo adjunto no es el de tipo seleccionado'
      }
    }

    var uploader = $scope.uploader = new FileUploader({
      url: SERVICE_URL_CONSTANT.rosario+'/file/uploadFilePortfolio?userId='+editReflectionVm.userId 
    })

   // a sync filter
    uploader.filters.push({
      name: 'syncFilter',
      fn: function(item, options) {
      console.log('syncFilter');
      return this.queue.length < 10
      }
    });

   // an async filter
    uploader.filters.push({
      name: 'asyncFilter',
      fn: function(item, options, deferred) {
        console.log('asyncFilter');
        setTimeout(deferred.resolve, 1e3)
      }
    })

    uploader.filters.push({
      name: 'emptyFilter',
      fn: function(item, options) {
        return true
      }
    })

    uploader.onWhenAddingFileFailed = function(item, filter, options) {
      //console.info('onWhenAddingFileFailed', item, filter, options)
      editReflectionVm.errorMsgFileType    = 'El archivo no es el de tipo seleccionado'
      editReflectionVm.disableButtonUpload = true
      $('#inputFileUpload').val(null)
    }

    uploader.onAfterAddingFile = function(fileItem) {
      //console.info('onAfterAddingFile', fileItem)
      editReflectionVm.errorMsgFileType    = ''
      editReflectionVm.disableButtonUpload = false
    }

    uploader.onSuccessItem = function(fileItem, response, status, headers) {
      //console.info('onSuccessItem', fileItem, response, status, headers)
      if(response.status){
        editReflectionVm.fileName   = response.data
        editReflectionVm.attachFile = fileItem.file.name 
        editReflectionVm.errorMsg   = false
      }
    }
    uploader.onErrorItem = function(fileItem, response, status, headers) {
      //console.info('onErrorItem', fileItem, response, status, headers)
      editReflectionVm.errorMsg = true
    }

    uploader.onCompleteItem = function(fileItem, response, status, headers) {
      //console.info('onCompleteItem', fileItem, response, status, headers)
      editReflectionVm.loading = false
      editReflectionVm.STATIC_IMAGE_URL = true         
    }

    uploader.onBeforeUploadItem = function(item) {
      let header = {
        userId : editReflectionVm.userId,
      }
      item.formData.push(header)
      editReflectionVm.loading  = true
      editReflectionVm.errorMsg = false 
    }

    function remove(){
      editReflectionVm.attachFile = ''
      uploader.clearQueue()
      editReflectionVm.STATIC_IMAGE_URL = false
      editReflectionVm.loading = false
      editReflectionVm.errorMsg = false 
      editReflectionVm.fileName = ''
    }

  //forms methods
    function hasError (input) {
      if (input.$invalid && (input.$dirty || input.$touched)) {
        return 'has-error'
      }
    }

    function showErrorMessages (input) {
      return input.$dirty || input.$touched
    }

    function validateForm (form) {
      if (editReflectionVm.itemConfig.idEvidence == editReflectionVm.registryId){
        return form.$invalid || editReflectionVm.fileName == '' || editReflectionVm.errorMsgFileType != ''
      }else{
        if (editReflectionVm.isAddingEvidence){
          return form.$invalid || editReflectionVm.fileName == '' || editReflectionVm.errorMsgFileType != ''
        }else{
          return form.$invalid
        }
        
      }
      
    }

    function setClassTitle(){
      if (editReflectionVm.itemConfig.idEvidence == editReflectionVm.registryId){
        //editReflectionVm.classTitle = 'col-md-3'
        editReflectionVm.classTitle = 'col-md-3'
      }else{
        editReflectionVm.classTitle = 'col-md-3'
      }
    }

  //utils function
    function isImageType(fileTypeId){
      return fileTypeId == editReflectionVm.globalFileTypes.image
    }

    function isDocumentType(fileTypeId){
      return fileTypeId == editReflectionVm.globalFileTypes.document
    }

    function isVideoType(fileTypeId){
      return fileTypeId == editReflectionVm.globalFileTypes.video
    }

    function isAudioType(fileTypeId){
      return fileTypeId == editReflectionVm.globalFileTypes.audio
    }
  }
}

EditReflectionCtrl.$inject = ['$scope', '$mdDialog', 'PortfolioSrv', 'PortfolioModalSrv', 
                              'GlobalConfig', 'FileUploader', 'SERVICE_URL_CONSTANT']



// WEBPACK FOOTER //
// ./src/app/u-faculty/portfolio/myPortfolio/modals/editReflectionCtrl.js